
export const EventBus = /*#__PURE__*/ (function () {
    function EventBus() {
        var description =
            arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

        _classCallCheck(this, EventBus);

        this.eventTarget = document.appendChild(
            document.createComment(description)
        );

        this.eventList = [];
    }

    _createClass(EventBus, [
        {
            key: "on",
            value: function on(type, listener) {
                this.eventList.push(type);
                this.eventTarget.addEventListener(type, listener);
            },
        },
        {
            key: "has",
            value: function has(type) {
                return this.eventList.includes(type);
            },
        },
        {
            key: "once",
            value: function once(type, listener) {
                this.eventTarget.addEventListener(type, listener, {
                    once: true,
                });
            },
        },
        {
            key: "off",
            value: function off(type, listener) {
                if (this.eventList.includes(type)) {
                    this.eventList.splice(this.eventList.indexOf(type), 1);
                }
                this.eventTarget.removeEventListener(type, listener);
            },
        },
        {
            key: "emit",
            value: function emit(type, detail) {
                return this.eventTarget.dispatchEvent(
                    new CustomEvent(type, {
                        detail,
                    })
                );
            },
        },
    ]);

    return EventBus;
})();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}

function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}